import { render, staticRenderFns } from "./GroupsByRule.vue?vue&type=template&id=19f2ae2c"
import script from "./GroupsByRule.vue?vue&type=script&lang=js"
export * from "./GroupsByRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports